$(function() {
  $('.wishlist-button').click(function() {
    $(this).toggleClass('wishlist-button--active');
  });
});